__turbopack_context__.v({
  "heading": "HeadingAndSubheading-module__DMjfmW__heading",
  "subheading": "HeadingAndSubheading-module__DMjfmW__subheading",
});
